import React from "react";
import Button from "../ui-components/Button";

export function sharingInfoButton(
  sharing,
  setShowSharing,
  intl
) {
  if (!(sharing || []).length) {
    return <span className="text-xl">-</span>;
  }
  if (!sharing[0]) {
    return <></>;
  }

  return (
    <div>
      <Button
        styleType="empty"
        className="text-xxs h-6"
        onClick={(e) => {
          setShowSharing(sharing);
          e.stopPropagation();
        }}
      >
        {sharing.length} {intl.formatMessage({ id: "users" })}
      </Button>
    </div>
  );
}
